import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import { Toaster } from "./components/ui/sonner";

import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import ProtectedRoute from "./components/ProtectedRoute";

import Home from "./pages/Home";
import Explore from "./pages/Explore";
import ProjectDetail from "./pages/ProjectDetail";
import Companies from "./pages/Companies";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Saved from "./pages/Saved";
import TVMode from "./pages/TVMode";
import Login from "./pages/Login";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import AgentPortal from "./pages/AgentPortal";
import AdminLayout from "./pages/AdminLayout";
import PresentationViewer from "./pages/PresentationViewer";

function App() {
    return (
        <div className="App">
            <AuthProvider>
                <BrowserRouter>
                    <Navbar />
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/explore" element={<Explore />} />
                        <Route path="/projects/:slug" element={<ProjectDetail />} />
                        <Route path="/companies" element={<Companies />} />
                        <Route path="/about" element={<About />} />
                        <Route path="/contact" element={<Contact />} />
                        <Route path="/saved" element={<Saved />} />
                        <Route path="/tv" element={<TVMode />} />
                        <Route path="/login" element={<Login />} />
                        <Route path="/forgot-password" element={<ForgotPassword />} />
                        <Route path="/reset-password" element={<ResetPassword />} />
                        <Route
                            path="/presentations/:id/view"
                            element={
                                <ProtectedRoute roles={["sales_agent", "company_admin", "super_admin"]}>
                                    <PresentationViewer />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/agent"
                            element={
                                <ProtectedRoute roles={["sales_agent", "company_admin", "super_admin"]}>
                                    <AgentPortal />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/admin/*"
                            element={
                                <ProtectedRoute roles={["super_admin", "company_admin"]}>
                                    <AdminLayout />
                                </ProtectedRoute>
                            }
                        />
                    </Routes>
                    <Footer />
                    <Toaster theme="dark" position="top-right" />
                </BrowserRouter>
            </AuthProvider>
        </div>
    );
}

export default App;
